import { Card as CardMUI, Divider as DividerMUI } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Card = styled(CardMUI)`
  padding: 4rem 4rem;
  width: 100%;

  @media (max-width: ${theme.breakpoints.values.md}px) {
    padding: 1rem 1rem;
  }
`;

export const SideCard = styled(CardMUI)`
  padding: 1rem 1rem;
  width: 30rem;
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;

  @media (max-width: ${theme.breakpoints.values.md}px) {
    width: 100%;
    position: relative;
  }
`;

export const Logo = styled('img')`
  item: "true";
  width: 126px;
  height: 53px;
  alt: "Billz";
`;

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const Root = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  gap: 1rem;

  @media (max-width: ${theme.breakpoints.values.md}px) {
    justify-content: flex-start;
    align-items: stretch;
    flex-direction: column-reverse;
  }
`;

export const RowSpaceBetween = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
`;

export const HeaderRowSpaceBetween = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  height: auto;

  @media (max-width: ${theme.breakpoints.values.md}px) {
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    gap: 1rem;
  }
`;

export const ContractorsRowSpaceBetween = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  height: auto;
  margin-top: 1rem;

  @media (max-width: ${theme.breakpoints.values.md}px) {
    justify-content: flex-start;
    align-items: space-between;
    flex-direction: column;
    gap: 1rem;
  }
`;

export const FooterVerticalSpaceBetween = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  height: auto;
  margin-top: 1rem;
  gap: 1rem;

  @media (max-width: ${theme.breakpoints.values.md}px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

export const TitleRow = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  margin-top: 5rem;
`;

export const RowCenter = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
`;

export const RowFlexEnd = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-end;
`;

export const VerticalLeftAligned = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;

  @media (max-width: ${theme.breakpoints.values.md}px) {
    gap:1rem;
  }
`;

export const VerticalRightAligned = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
`;

export const VerticalSpaceBetween = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  height: 100%;
`;

export const HorizontalSpaceBetween = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  height: 100%;
`;

export const Divider = styled(DividerMUI)`
  margin: 10px 0;
  background-color: rgba(52, 71, 103, 0.4);
`;

